// import React from 'react'
// import { Auth0Provider } from '@auth0/auth0-react'
// import { withRouter } from 'react-router-dom'

// class Auth0ProviderWithHistory extends React.Component {
//   clientId = 'eUsZu1ANknCVj2696awmgk36kvjVVctD'
//   domain = 'dev-31f54t0l.us.auth0.com'
//   audience = 'https://saber-sport.com'

//   onRedirectCallback = (appState) => {
//     this.props.history.push(appState?.returnTo || window.location.pathname)
//   }

//   render () {
//     return (
//       <Auth0Provider
//         domain={this.domain}
//         clientId={this.clientId}
//         redirectUri={window.location.origin}
//         onRedirectCallback={this.onRedirectCallback}
//         audience={this.audience}
//       >
//         {this.props.children}
//       </Auth0Provider>
//     )
//   }
// }

// export default withRouter(Auth0ProviderWithHistory)

import React from 'react'
import { useHistory, withRouter } from 'react-router-dom'
import { Auth0Provider } from '@auth0/auth0-react'

const clientId = 'eUsZu1ANknCVj2696awmgk36kvjVVctD'

const Auth0ProviderWithHistory = ({ children }) => {
  const domain = 'dev-31f54t0l.us.auth0.com'
  const audience = 'https://saber-sport.com'

  const history = useHistory()

  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())
  if (params.error === 'access_denied' && params.error_description) {
    console.error(params.error_description)
    window.alert('There was a problem logging you in, you do not have permission to use this service')
  }
  const onRedirectCallback = (appState) => {
    history.push(appState?.returnTo || window.location.pathname)
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      audience={audience}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}

export default withRouter(Auth0ProviderWithHistory)
